export default __webpack_public_path__ + "static/media/chatting.03f07f11.png";